window.confirmSize = (event) => {
  const variant = product.variants.find((v) => v.id == event.detail.code);
  if (!variant) return;
  variant.options.forEach((optionValue, index) => {
    const optionName = product.options[index];
    const escapedOptionValue = optionValue.replace(/"/g, '\\"');
    const selector = `input[name^="${optionName}"][title="${escapedOptionValue}"]`;
    const element = document.querySelector(selector);
    element?.click();
  });
};

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const widget = document.querySelector('#onlinesizing-widget');
  widget?.setAttribute('variant-id', event.data.variant.id);
});